import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-100 h-100 position-relative" };
const _hoisted_2 = {
    key: 0,
    class: "component-title fw-bold small mb-3"
};
const _hoisted_3 = {
    class: "configuration-options position-absolute",
    style: { "z-index": "999", "background-color": "rgba(255,255,255,0.8)" }
};
const _hoisted_4 = { class: "d-flex flex-column flex-md-row rounded" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center mx-3"
};
const _hoisted_7 = { class: "form-check" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    class: "form-check-label",
    for: "engravingPrintModeRequest"
};
const _hoisted_10 = {
    key: 2,
    class: "mx-3",
    style: { "max-width": "190px" }
};
const _hoisted_11 = ["for"];
const _hoisted_12 = ["id"];
const _hoisted_13 = { class: "p-2" };
const _hoisted_14 = ["id"];
const _hoisted_15 = ["for"];
const _hoisted_16 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-check-lg",
    viewBox: "0 0 16 16"
};
const _hoisted_17 = {
    key: 0,
    class: "small text-secondary ms-2"
};
const _hoisted_18 = {
    key: 1,
    class: "pb-1"
};
const _hoisted_19 = { class: "w-100 h-100 d-flex align-items-center pt-5 mt-5" };
const _hoisted_20 = { class: "position-relative h-100 canvas-wrapper" };
const _hoisted_21 = ["id"];
const _hoisted_22 = ["id"];
import { Canvas, FabricImage, filters, initFilterBackend } from 'fabric';
import ImageManager from '@/Configurator/Shared/ImageManager.vue';
import TextManager from '@/Configurator/Shared/TextManager.vue';
import { onMounted, ref } from 'vue';
import ColorManager from '@/Configurator/Shared/ColorManager.vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { loadTenantConfigs, standardFunctions } from '@/Configurator/Composables/standardFunctions';
import { debounce } from 'lodash';
import { canvasExport } from '../Composables/canvasExport';
import { useI18n } from 'vue-i18n';
import FillLineOptionManager from '../Shared/FillLineOptionManager.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BottleConfiguration',
    props: {
        configurationId: String,
        tenantId: String,
        bottle: Object,
        printAreaId: String
    },
    emits: ['update', 'blockFurtherConfiguration'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        let { mmToPx } = standardFunctions();
        let { exportCanvasAsPNG } = canvasExport();
        const props = __props;
        const emit = __emit;
        const standardProductType = ref(null);
        const configurationKey = ref(Math.random().toString(36).substring(7));
        const maxTextsAmount = ref(3); //Mögliche Texte Anzahl
        const maxImagesAmount = ref(4); //Mögliche Bilder Anzahl
        const scaleFactor = ref(3.7); //Scale Faktor?
        const shouldBlockFurtherConfiguration = ref(true); //Blockiere weitere Konfiguration //TODO: check if needed and when to set? Component does not allow further configuration
        const furtherConfigurationBlocked = ref(false); //Weitere Konfiguration blockiert
        const printAreaGridActive = ref(false); //Druckbereich Raster aktiv
        const configurationComponentId = ref('000000'); //Konfigurationskomponenten ID
        const bottleHeight = ref(316); //Flaschenhöhe in mm
        const bottleDiameter = ref(82); //Durchmesser in mm
        const bottleBottomDistanceToPrintArea = ref(30); //Abstand Druckbereich zum Boden in mm
        const bottlePrintWidth = ref(250); //Druckbereich Breite in mm
        const bottlePrintHeight = ref(80); //Druckbereich Höhe in mm
        const bottleConfigImageSrc = ref(''); //Flaschenkonfiguration Bild
        //Colors
        const textColors = ref([]); //Textfarben
        const imageColors = ref([]); //Bildfarben
        const requiresDigitalPrintMode = ref(false); //Benötigt Digitaldruckmodus
        const maxColors = ref(null);
        //Configuration components
        const bottleCanvas = ref(new Canvas()); //Flaschen
        const bottlepreview = ref(new Canvas()); //Flaschen Vorschau
        const bottleConfigImage = ref(null); //Flaschenkonfiguration Bild
        const bottleOverlay = ref(0); //Flaschen Overlay
        const allowedPrintModes = ref([]); //Erlaubte Druckmodi
        const engravingPrintModeRequest = ref(false); //Gravur Druckmodus Anfrage
        const enableEngravingPrintModeSelection = ref(false); //Gravur Druckmodus Auswahl aktivieren
        const hasFillLineOption = ref(false); //Hat die Flasche die Option einer Füllstandslinie?
        const printFillLine = ref(false); //Soll die Füllstandslinie gedruckt werden?
        const configurationIsExtensible = ref(true); //Konfiguration ist erweiterbar
        const applyDynamicStyles = () => {
            let styleTag = document.getElementById('dynamic-style');
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = 'dynamic-style' + props.printAreaId;
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = `
    .bottlepreviewcontainer${props.printAreaId} .canvas-container {
        left: ${((mmToPx(bottlePrintWidth.value) / scaleFactor.value / 4) - (mmToPx(bottleDiameter.value) / scaleFactor.value / 2))}px;
    }
    .bottleprintcontainer${props.printAreaId} .canvas-container {
        bottom: ${(mmToPx(bottleBottomDistanceToPrintArea.value) / scaleFactor.value)}px;
    }
  `;
        };
        const saveConfigurationDebounced = debounce(() => {
            saveConfiguration();
        }, 1000); //Save configuration debounce after 1 seconds
        onMounted(async () => {
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            loadConfiguration();
        });
        function loadConfiguration() {
            axios.post(route('configurator.bottleConfiguration.load', props.configurationId), {
                bottleId: props.bottle ? props.bottle.id : null,
                printAreaId: props.printAreaId
            })
                .then(function (response) {
                configurationComponentId.value = response.data.id;
                bottleHeight.value = response.data.bottle.height;
                bottleDiameter.value = response.data.bottle.diameter;
                allowedPrintModes.value = response.data.bottle.allowedPrintModes;
                hasFillLineOption.value = response.data.bottle.hasFillLineOption;
                bottleBottomDistanceToPrintArea.value = response.data.printArea.bottomDistanceToPrintArea;
                bottlePrintWidth.value = response.data.printArea.printWidth;
                bottlePrintHeight.value = response.data.printArea.printHeight;
                bottleConfigImageSrc.value = response.data.printArea.configImage;
                maxColors.value = response.data.printArea.maxColors;
                configurationIsExtensible.value = response.data.isExtensible;
                bottleCanvas.value = new Canvas('container' + props.printAreaId, {
                    width: mmToPx(bottlePrintWidth.value) / scaleFactor.value,
                    height: mmToPx(bottlePrintHeight.value) / scaleFactor.value
                });
                applyDynamicStyles();
                assembleImages();
                loadPrintConfigurationData(); //Load print configuration data if already saved
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadPrintConfigurationData() {
            if (configurationComponentId.value) {
                axios.post(route('configurator.printConfiguration.load', configurationComponentId.value), {
                    configurationType: 'bottle'
                })
                    .then(function (response) {
                    if (response.data.configuration) {
                        new Canvas()
                            .loadFromJSON(response.data.configuration)
                            .then((canvas) => {
                            bottleCanvas.value.clear();
                            // Neue Canvas-Größe (falls sie sich geändert hat)
                            const newWidth = bottleCanvas.value.width;
                            const newHeight = bottleCanvas.value.height;
                            // Originalgröße aus gespeicherten Daten
                            const originalWidth = canvas.width;
                            const originalHeight = canvas.height;
                            // Skalierungsfaktoren berechnen
                            const scaleX = newWidth / originalWidth;
                            const scaleY = newHeight / originalHeight;
                            document.fonts.ready.then(() => {
                                canvas.getObjects().forEach((obj) => {
                                    // Skalierung anpassen
                                    obj.scaleX = (obj.scaleX || 1) * scaleX;
                                    obj.scaleY = (obj.scaleY || 1) * scaleY;
                                    obj.left = (obj.left || 0) * scaleX;
                                    obj.top = (obj.top || 0) * scaleY;
                                    obj.setCoords();
                                    if (response.data.editingBlockedImages.includes(obj.get('id')) || response.data.editingBlockedTexts.includes(obj.get('id'))) {
                                        obj.set('editingBlocked', true);
                                        obj.selectable = false;
                                    }
                                    else {
                                        obj.set('editingBlocked', false);
                                        if (!obj.get('isFullDesign')) {
                                            obj.selectable = true;
                                        }
                                        else {
                                            obj.selectable = false;
                                        }
                                    }
                                    bottleCanvas.value.add(obj);
                                });
                                bottleCanvas.value.renderAll();
                                configurationKey.value = Math.random().toString(36).substring(7);
                            });
                        });
                    }
                    if (response.data.printModeId) {
                        engravingPrintModeRequest.value = response.data.printModeId == 3;
                    }
                    bottleCanvas.value.on('object:modified', () => {
                        saveConfigurationDebounced();
                    });
                })
                    .catch(function (error) {
                    console.log(error);
                });
            }
        }
        function assembleImages() {
            //Bottle images
            var bottlepreviewWidth = mmToPx(bottleDiameter.value) / scaleFactor.value;
            var bottlepreviewHeight = mmToPx(bottleHeight.value) / scaleFactor.value;
            if (bottlepreview.value) {
                bottlepreview.value.clear();
                bottlepreview.value.dispose();
            }
            bottlepreview.value = new Canvas('bottlepreview' + props.printAreaId, {
                width: bottlepreviewWidth,
                height: bottlepreviewHeight
            });
            FabricImage.fromURL(bottleConfigImageSrc.value).then(function (oImg) {
                // oImg.scaleToWidth(bottlepreviewWidth);
                oImg.scaleToHeight(bottlepreviewHeight); //TODO: better scalteToWidth or scaleToHeight?
                oImg.selectable = false;
                oImg.set({
                    left: 0,
                    top: 0
                });
                bottlepreview.value.add(oImg);
                bottlepreview.value.sendObjectToBack(oImg);
                bottlepreview.value.renderAll(); //TODO: check: in old version, only set for drehverschluss
                bottleConfigImage.value = oImg;
            });
        }
        function changeBottleOverlayFilter() {
            //Set filter size, important for images bigger 2048px
            initFilterBackend();
            var filter = new filters.BlendColor({
                color: '#eee',
                mode: 'difference',
                alpha: bottleOverlay.value
            });
            if (bottleConfigImage.value) {
                bottleConfigImage.value.filters = [];
                bottleConfigImage.value.applyFilters();
                bottleConfigImage.value.filters.push(filter);
                bottleConfigImage.value.applyFilters();
            }
            bottlepreview.value.renderAll();
        }
        function updateBottleCanvas(objects, updateType) {
            let textObjects = bottleCanvas.value.getObjects('textbox');
            let imageObjects = bottleCanvas.value.getObjects('image');
            let svgObjects = bottleCanvas.value.getObjects('group', 'path');
            bottleCanvas.value.clear();
            objects.forEach((obj) => {
                bottleCanvas.value.add(obj);
                if (updateType == 'image') {
                    bottleCanvas.value.sendObjectToBack(obj);
                }
            });
            if (updateType == 'image') {
                textObjects.forEach((obj) => {
                    bottleCanvas.value.add(obj);
                });
            }
            else {
                imageObjects.forEach((obj) => {
                    bottleCanvas.value.add(obj);
                    bottleCanvas.value.sendObjectToBack(obj);
                });
                svgObjects.forEach((obj) => {
                    bottleCanvas.value.add(obj);
                    bottleCanvas.value.sendObjectToBack(obj);
                });
            }
            bottleCanvas.value.renderAll();
            saveConfigurationDebounced();
        }
        function updateTextColors(colors) {
            textColors.value = colors;
        }
        function updateImageColors(colors, reqDigitalPrintMode) {
            // console.log('updateImageColors');
            // console.log(colors);
            // console.log(reqDigitalPrintMode);
            imageColors.value = colors;
            requiresDigitalPrintMode.value = reqDigitalPrintMode;
        }
        async function saveConfiguration() {
            if (configurationComponentId.value) {
                let canvasSvgExport = bottleCanvas.value.toSVG();
                let canvasImageExport = null;
                const jsonConfiguration = JSON.stringify(bottleCanvas.value.toObject([
                    'left', 'top', 'width', 'height', 'scaleX', 'scaleY', 'angle', 'opacity',
                    'visible', 'shadow', 'stroke', 'strokeWidth', 'fill', 'text', 'fontSize',
                    'fontFamily', 'fontWeight', 'backgroundColor', 'path', 'src', 'borderColor', 'cornerColor', 'cornerSize', 'transparentCorners', 'borderDashArray', 'cornerStyle',
                    'id', 'url', 'colors', 'requiredPrintMode', 'belowMinDPI', 'individualTextFileUrl', 'designElement', 'isFullDesign', 'editingBlocked'
                ]));
                canvasImageExport = await exportCanvasAsPNG(bottleCanvas.value, jsonConfiguration, scaleFactor.value);
                axios.put(route('configurator.printConfiguration.update', configurationComponentId.value), {
                    configurationType: 'bottle',
                    configuration: jsonConfiguration,
                    image: canvasImageExport,
                    svg: !canvasSvgExport.includes('xlink:href') ? canvasSvgExport : null,
                })
                    .catch(function (error) {
                    console.log(error);
                });
                emit('update');
            }
            else {
                console.error('Cannot save bottle canvas. Configuration Component ID is null');
            }
        }
        function setConfigurationBlock(blocked, message = '') {
            furtherConfigurationBlocked.value = blocked;
            if (blocked) {
                Swal.fire({
                    title: t('Achtung!'),
                    html: message,
                    icon: 'error',
                    confirmButtonText: t("Weitermachen"),
                    confirmButtonColor: "#528399",
                    footer: '<a href="#" data-bs-toggle="modal" data-bs-target="#printModes">' + t('Weitere Informationen zu unseren Druckverfahren') + '</a>'
                });
            }
            emit('blockFurtherConfiguration', blocked);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.bottle)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(props.bottle.name.includes('(') ? props.bottle.name : props.bottle.name + ' (' + props.bottle.volume + ')'), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            (bottleCanvas.value && configurationIsExtensible.value && allowedPrintModes.value.length > 0)
                                ? (_openBlock(), _createBlock(ImageManager, {
                                    configurationComponentId: configurationComponentId.value,
                                    key: configurationKey.value,
                                    maxImagesAmount: maxImagesAmount.value,
                                    initialCanvas: bottleCanvas.value,
                                    allowedPrintModes: allowedPrintModes.value,
                                    onUpdate: updateBottleCanvas,
                                    onUsedColors: updateImageColors
                                }, null, 8, ["configurationComponentId", "maxImagesAmount", "initialCanvas", "allowedPrintModes"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                            (bottleCanvas.value && configurationIsExtensible.value)
                                ? (_openBlock(), _createBlock(TextManager, {
                                    maxTextsAmount: maxTextsAmount.value,
                                    initialCanvas: bottleCanvas.value,
                                    configurationComponentId: configurationComponentId.value,
                                    key: configurationKey.value,
                                    onUpdate: updateBottleCanvas,
                                    onUsedColors: updateTextColors
                                }, null, 8, ["maxTextsAmount", "initialCanvas", "configurationComponentId"]))
                                : _createCommentVNode("", true)
                        ]),
                        (hasFillLineOption.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(FillLineOptionManager, {
                                    configurationComponentId: configurationComponentId.value,
                                    onUpdate: _cache[0] || (_cache[0] = ($event) => (printFillLine.value = $event.hasFillLinePrint))
                                }, null, 8, ["configurationComponentId"])
                            ]))
                            : _createCommentVNode("", true),
                        (allowedPrintModes.value.includes(3))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        value: "1",
                                        id: "engravingPrintModeRequest",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((engravingPrintModeRequest).value = $event)),
                                        disabled: !enableEngravingPrintModeSelection.value
                                    }, null, 8, _hoisted_8), [
                                        [_vModelCheckbox, engravingPrintModeRequest.value]
                                    ]),
                                    _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('Gravur-Druck gewünscht')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (standardProductType.value != 'glass')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("label", {
                                    for: 'bottleDarken' + props.printAreaId,
                                    class: "form-label fw-bold"
                                }, _toDisplayString(_unref(t)('Darstellung verdunkeln')), 9, _hoisted_11),
                                _withDirectives(_createElementVNode("input", {
                                    type: "range",
                                    class: "form-range",
                                    id: 'bottleDarken' + props.printAreaId,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((bottleOverlay).value = $event)),
                                    min: "0",
                                    max: "0.5",
                                    step: "0.05",
                                    onChange: changeBottleOverlayFilter
                                }, null, 40, _hoisted_12), [
                                    [_vModelText, bottleOverlay.value]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "btn-check",
                                id: 'bottle-grid-' + props.printAreaId,
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((printAreaGridActive).value = $event))
                            }, null, 8, _hoisted_14), [
                                [_vModelCheckbox, printAreaGridActive.value]
                            ]),
                            _createElementVNode("label", {
                                class: "btn btn-primary d-inline-flex align-items-center",
                                for: 'bottle-grid-' + props.printAreaId
                            }, [
                                (printAreaGridActive.value)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("path", { d: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", {
                                    class: _normalizeClass({ 'ms-2': printAreaGridActive.value })
                                }, "Raster", 2)
                            ], 8, _hoisted_15)
                        ])
                    ]),
                    (hasFillLineOption.value && printFillLine.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(t)('Wir tragen den gewünschten Eichstrich in das Maßblatt ein, das wir Ihnen vor Produktionsbeginn zur Freigabe zusenden.')), 1))
                        : _createCommentVNode("", true)
                ]),
                (hasFillLineOption.value && printFillLine.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                    : _createCommentVNode("", true),
                (allowedPrintModes.value.length > 0)
                    ? (_openBlock(), _createBlock(ColorManager, {
                        key: 2,
                        maxColors: maxColors.value,
                        textColors: textColors.value,
                        imageColors: imageColors.value,
                        imagesAmount: bottleCanvas.value.getObjects('image').length,
                        requiresDigitalPrintMode: requiresDigitalPrintMode.value,
                        shouldBlockFurtherConfiguration: shouldBlockFurtherConfiguration.value,
                        allowedPrintModes: allowedPrintModes.value,
                        configurationType: 'bottle',
                        printConfigurationUuid: configurationComponentId.value,
                        preSelectedPrintType: engravingPrintModeRequest.value ? 3 : null,
                        onBlockFurtherConfiguration: setConfigurationBlock,
                        onCanSelectEngravingPrintMode: _cache[4] || (_cache[4] = ($event) => { enableEngravingPrintModeSelection.value = $event; if (!$event) {
                            engravingPrintModeRequest.value = false;
                        } })
                    }, null, 8, ["maxColors", "textColors", "imageColors", "imagesAmount", "requiresDigitalPrintMode", "shouldBlockFurtherConfiguration", "allowedPrintModes", "printConfigurationUuid", "preSelectedPrintType"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                        style: _normalizeStyle({ height: _unref(mmToPx)(bottleHeight.value) / scaleFactor.value + 'px' })
                    }, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", {
                                class: _normalizeClass('bottlepreviewcontainer' + props.printAreaId)
                            }, [
                                _createElementVNode("canvas", {
                                    id: 'bottlepreview' + props.printAreaId
                                }, null, 8, _hoisted_21)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass('bottleprintcontainer' + props.printAreaId)
                            }, [
                                _createElementVNode("div", {
                                    class: "printinfo-front",
                                    style: _normalizeStyle({
                                        left: ((_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 4) - 23) + 'px',
                                        bottom: ((_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value / 2) + 15) + 'px',
                                        color: printAreaGridActive.value ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                                    })
                                }, _toDisplayString(_unref(t)('Vorne')), 5),
                                _createElementVNode("div", {
                                    class: "printinfo-front-plus",
                                    style: _normalizeStyle({
                                        left: (_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 4) + 'px',
                                        height: (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value / 2) + 'px',
                                        bottom: (_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + 'px',
                                        color: printAreaGridActive.value ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                                    })
                                }, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("span", null, "+", -1)
                                    ]))], 4),
                                _createElementVNode("div", {
                                    class: "printinfo-back",
                                    style: _normalizeStyle({
                                        left: ((_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 4 * 3) - 25) + 'px',
                                        bottom: ((_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value / 2) + 15) + 'px',
                                        color: printAreaGridActive.value ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                                    })
                                }, _toDisplayString(_unref(t)('Hinten')), 5),
                                _createElementVNode("div", {
                                    class: "printinfo-back-plus",
                                    style: _normalizeStyle({
                                        left: (_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 4 * 3) + 'px',
                                        height: (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value / 2) + 'px',
                                        bottom: (_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + 'px',
                                        color: printAreaGridActive.value ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                                    })
                                }, [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("span", null, "+", -1)
                                    ]))], 4),
                                _createElementVNode("div", {
                                    class: "printline",
                                    style: _normalizeStyle({
                                        left: ((_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 2) - 1) + 'px',
                                        height: (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value) + 'px',
                                        bottom: (_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + 'px'
                                    })
                                }, null, 4),
                                _createElementVNode("div", {
                                    class: "printareainfo",
                                    style: _normalizeStyle({
                                        left: (_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value / 2) + 'px',
                                        bottom: (_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value - 40) + 'px'
                                    })
                                }, _toDisplayString(_unref(t)('Druckbereich')), 5),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["position-absolute", { 'printAreaGrid': printAreaGridActive.value }]),
                                    style: _normalizeStyle({
                                        width: (_unref(mmToPx)(bottlePrintWidth.value) / scaleFactor.value) + 'px',
                                        height: (_unref(mmToPx)(bottlePrintHeight.value) / scaleFactor.value) + 'px',
                                        bottom: (_unref(mmToPx)(bottleBottomDistanceToPrintArea.value) / scaleFactor.value) + 'px'
                                    })
                                }, null, 6),
                                _createElementVNode("canvas", {
                                    id: 'container' + props.printAreaId,
                                    class: "bottlePrintArea"
                                }, null, 8, _hoisted_22)
                            ], 2)
                        ])
                    ], 4)
                ])
            ]));
        };
    }
});
